import ChangeStatusButtonWarning from './ChangeStatusButtonWarning';

export default ChangeStatusButtonWarning;
